/**
 * Product Card - Add to Cart functionality
 */

// Ensure this only runs once
if (!window.productCardInitialized) {
  window.productCardInitialized = true;

  // Handle add to cart buttons on product cards
  document.addEventListener('click', async function(e) {
    const addToCartBtn = e.target.closest('[data-add-to-cart]');

    if (addToCartBtn) {
      e.preventDefault();

      // Prevent double clicks
      if (addToCartBtn.disabled) return;

      const variantId = addToCartBtn.dataset.variantId;
      const productUrl = addToCartBtn.dataset.productUrl;

      if (!variantId) {
        console.error('No variant ID found');
        return;
      }

      // Disable button during request
      addToCartBtn.disabled = true;
      addToCartBtn.style.opacity = '0.6';

      try {
        // Use global cart function
        await window.CartFunctions.addToCart(variantId, 1);
      } catch (error) {
        console.error('Failed to add to cart:', error);
      } finally {
        // Re-enable button after a short delay to prevent double clicks
        setTimeout(() => {
          addToCartBtn.disabled = false;
          addToCartBtn.style.opacity = '1';
        }, 500);
      }
    }
  });

  // Listen to cart updates to refresh any cart-dependent UI
  document.addEventListener('cart:updated', function(e) {
    console.log('Cart updated at:', e.detail.timestamp);
    // Add any additional UI updates here if needed
  });
}
